import type { Schemas } from './client';

/**
 * Short names for the M19 platform types (generated from the M19 OpenAPI contract into
 * `schema.d.ts`). Call the endpoints with the typed `api.GET/POST/PATCH` from `./client`.
 */
export type PlatformRole = Schemas['PlatformMe']['role'];
export type PlatformMe = Schemas['PlatformMe'];
export type PlatformTokens = Schemas['PlatformTokens'];
export type PlatformMfaChallenge = Schemas['PlatformMfaChallenge'];
export type PlatformLoginResult = Schemas['PlatformLoginResult'];
export type PlatformAuditEntry = Schemas['PlatformAuditEntry'];
export type MfaSetup = Schemas['PlatformMfaSetup'];
export type MfaRecoveryCodes = Schemas['PlatformMfaRecoveryCodes'];
export type PlatformAdmin = Schemas['PlatformAdmin'];
export type PlatformDashboard = Schemas['PlatformDashboard'];
export type PlatformHealth = Schemas['PlatformHealth'];
export type SupportGrant = Schemas['SupportGrant'];
export type PlatformSupportGrant = Schemas['PlatformSupportGrant'];
export type SupportSummary = Schemas['SupportSummary'];

export function isMfaChallenge(r: PlatformLoginResult): r is PlatformMfaChallenge {
  return 'mfaRequired' in r && r.mfaRequired;
}
